import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-394d2326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-light pb-2 text-center row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rounded px-2",
  height: "30",
  alt: "logo",
  id: "logo"
}, null, -1))
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = {
  class: "collapse navbar-collapse d-flex justify-content-around",
  id: "navbarText"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "navbar-light text-center d-flex justify-content-around shadow-sm bg-light row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.primary_links, (link, ix) => {
            return (_openBlock(), _createElementBlock("ul", {
              class: "navbar-nav",
              key: link.href
            }, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["nav-link fw-bold", { active: ix === 0 }]),
                  "aria-current": "page",
                  to: link.href
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" | " + _toDisplayString(link.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.secondary_links, (link, ix) => {
        return (_openBlock(), _createElementBlock("div", {
          key: link.href,
          class: "col-12 col-sm-12 col-md-6 col-lg-2"
        }, [
          _createVNode(_component_router_link, {
            class: _normalizeClass([{ active: ix === 0 }, "nav-link fst-italic text-secondary"]),
            "aria-current": "page",
            to: link.href
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.name), 1)
            ]),
            _: 2
          }, 1032, ["class", "to"])
        ]))
      }), 128))
    ])
  ]))
}